import { buildHref } from "@softmax/web-addresses";
import {
  curatedCoworldName,
  gamePresentationOf,
} from "@softmax/web-features/coworlds";
import {
  leavesTheSite,
  type CoworldNav,
} from "@softmax/web-features/site/records";
import {
  curatedDocs,
  coworldIconOf,
  previewNames,
} from "@/features/preview/records";
import type { GamePageContext } from "../game-types";

export function gameRoomNavigation({
  game,
  wikiPages,
}: {
  readonly game: GamePageContext;
  readonly wikiPages: number | null;
}): CoworldNav | null {
  if (!game.coworldName) return null;

  const wiki = buildHref({ name: "game.wiki", game: game.address });
  const docs = curatedDocs({ slug: game.corpusSlug, game: game.address }) ?? {
    title: "Wiki",
    href: wikiPages
      ? buildHref({
          name: "game.wikiPage",
          game: game.address,
          page: ["main"],
        })
      : wiki,
  };
  const presentation = gamePresentationOf(game.corpusSlug);
  let docsLink: NonNullable<CoworldNav["docs"]> = {
    title: docs.title,
    href: docs.href,
  };

  if (!leavesTheSite(docs.href)) docsLink = { ...docsLink, matchPrefix: wiki };

  const result: CoworldNav = {
    name:
      previewNames[game.corpusSlug]?.name ??
      curatedCoworldName(game.coworldName) ??
      game.coworldName,
    coworldName: game.coworldName,
    corpusSlug: game.corpusSlug,
    route: { game: game.address },
    wikiPages,
    forumHref: buildHref({ name: "game.forum", game: game.address }),
    docs: docsLink,
    playHref: buildHref({ name: "game.play", game: game.address }),
    icon: coworldIconOf(game.corpusSlug) ?? null,
  };

  if (presentation.key === "generals-competition") {
    return {
      ...result,
      links: [{ label: "generals.io", href: "https://generals.io" }],
    };
  }

  if (game.corpusSlug === "marketing") {
    return {
      ...result,
      links: [
        {
          label: "The Desk",
          href: buildHref({ name: "game.home", game: game.address }),
        },
      ],
    };
  }

  return result;
}
